import * as React from 'react';
import { ButtonProps } from './ButtonTypes';
import { Icon, Typography } from '../../foundation';
import { useButtonTheme } from '../../../themes';
import { ButtonInputValidationError } from './ButtonErrors';

/**
 * The Button component is used to render a button.
 */
export const Button = ({
  children = undefined,
  colorStyle = 'default',
  disabled = false,
  fluid = false,
  icon = undefined,
  iconPosition = 'left',
  onClick = undefined,
  size = 'md',
  variant = 'primary',
  ...htmlProps
}: ButtonProps) => {
  const { buttonTheme } = useButtonTheme();
  const buttonIconContainerClass = buttonTheme['button-icon-container'];
 
  const buttonClasses = [
    buttonTheme['bsw-button'],
    buttonTheme[variant],
    buttonTheme[colorStyle],
    buttonTheme[`bsw-button-size--${size}`],
    icon ? buttonTheme['button-icon'] : undefined,
    fluid ? buttonTheme['fluid'] : undefined
  ].join(' ');

  /* @start Input validation */
  if (!children) {
    throw new ButtonInputValidationError('`children` prop cannot be empty');
  }
  /* @end Input validation */

  const renderButtonIcon = () => {
    const iconPositionClass = iconPosition === 'right' 
      ? buttonTheme['button-icon-right'] 
      : buttonTheme['button-icon-left'] 

    return (
      <span className={iconPositionClass}><Icon name={icon} disabled={disabled} size={'medium'}/></span>
    );
  };

  return (
    <button
      {...htmlProps}
      className={buttonClasses}
      disabled={disabled}
      onClick={onClick}
      type={htmlProps.type ? htmlProps.type : 'button'}>
      <div className={buttonIconContainerClass}>
        {iconPosition === 'left' && icon && renderButtonIcon()}
        <Typography tag="div" type="body-02" bold textAlign="center">
          {children}
        </Typography>
        {iconPosition === 'right' && icon && renderButtonIcon()}
      </div>
    </button>
  );
};
